import combatView from '../views/CombatView.vue'
import PlayerCombatView from '../views/PlayerCombatView.vue'
import RacesView from '../views/RacesView.vue'
import SpellsStaticView from '../views/SpellsStaticView.vue'
import ArtefactsView from '../views/CampaignArtefactsView.vue'
//----------------------------
// routes
//----------------------------
export default [
  {
    path: '/manage-combat/races/',
    name: 'combatRaces',
    component: RacesView,
    props: false, // <---
    meta: { title: 'Races', requiresAuth: true },
  },
  {
    path: '/manage-combat/artefacts/',
    name: 'combatArtefacts',
    component: ArtefactsView,
    props: false,
    meta: { title: 'Artefacts', requiresAuth: true },
  },
  {
    path: '/manage-combat/house-rules/',
    name: 'combatHouseRules',
    redirect: (to) => {
      const nextQuery = { ...to.query, popup: 'house-rules' }
      delete nextQuery.slug

      return {
        name: 'manageCombat',
        params: to.query.slug || to.params.slug ? { slug: to.query.slug || to.params.slug } : {},
        query: nextQuery,
      }
    },
    props: false,
    meta: { title: 'Combat [DM View]', requiresAuth: true },
  },
  {
    path: '/manage-combat/spells/',
    name: 'combatSpells',
    component: SpellsStaticView,
    props: false,
    meta: { title: 'Spells', requiresAuth: true },
  },
  {
    path: '/manage-combat/party-skills/',
    name: 'partySkills',
    redirect: (to) => {
      const nextQuery = { ...to.query, popup: 'party-skills' }
      delete nextQuery.slug

      return {
        name: 'manageCombat',
        params: to.query.slug ? { slug: to.query.slug } : {},
        query: nextQuery,
      }
    },
    props: false,
    meta: { title: 'Combat [DM View]', requiresAuth: true },
  },
  {
    path: '/manage-combat/party-runes/',
    name: 'partyRunes',
    redirect: (to) => {
      const nextQuery = { ...to.query, popup: 'party-runes' }
      delete nextQuery.slug

      return {
        name: 'manageCombat',
        params: to.query.slug ? { slug: to.query.slug } : {},
        query: nextQuery,
      }
    },
    props: false,
    meta: { title: 'Combat [DM View]', requiresAuth: true },
  },
  {
    path: '/manage-combat/log/',
    name: 'combatLog',
    redirect: (to) => {
      const nextQuery = { ...to.query, popup: 'log' }
      delete nextQuery.slug

      return {
        name: 'manageCombat',
        params: to.query.slug ? { slug: to.query.slug } : {},
        query: nextQuery,
      }
    },
    props: false,
    meta: { title: 'Log', requiresAuth: true },
  },
  {
    path: '/manage-combat/:slug?',
    name: 'manageCombat',
    component: combatView,
    props: true,
    meta: { title: 'Combat [DM View]', requiresAuth: true },
  },
  {
    path: '/player-combat/:slug?',
    name: 'playerCombat',
    component: PlayerCombatView,
    props: true,
    meta: { title: 'Combat [Player View]', requiresAuth: true },
  },
]
